module.exports = __webpack_public_path__ + "media/images/bg/shapes/online-courses-cc8f9fae82abcad1407906d9d5deb54a.svg";